import Swiper from "swiper";

function centeredSlider() {
  return {
    swiper: null,

    init() {
      this.$nextTick(() => {
        this.initSlider();
      });
    },

    initSlider() {
      if (!this.$refs.slider) {
        console.error("❌ Slider ref not found!");
        return;
      }

      // Count slides before Swiper init
      const slides = this.$refs.slider.querySelectorAll(".swiper-slide");

      // Remove slides that contain paragraph content
      slides.forEach((slide, index) => {
        const hasParagraph =
          slide.textContent.includes("paragraph") ||
          slide.innerHTML.includes("<p>");

        if (hasParagraph) {
          slide.remove();
        }
      });

      // Count remaining slides
      const remainingSlides =
        this.$refs.slider.querySelectorAll(".swiper-slide");

      this.swiper = new Swiper(this.$refs.slider, {
        loop: true,
        slidesPerView: "auto",
        autoplay: {
          delay: 5000,
          disableOnInteraction: true,
        },
        centeredSlides: true,
      });
    },
  };
}

export default centeredSlider;
